import React from "react";

export default function HorizonLine() {
  return <div className="my-4 border-t border-gray-900" />;
}
